import { Checkbox, List, ListItem, ListItemIcon, ListItemText, Popover } from '@material-ui/core';
import CustomButton from 'components/CustomInput/Button';
import usePostApprovalData from 'hooks/usePostApprovalData';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePostApprovalColumn } from 'store/column/reducer';
import styled from 'styled-components/macro';
import { produce } from 'utility/general';
import { useLocation } from 'react-router';

const SLayout = styled.div``;

const PostApprovalColumnButton = (props) => {
    const location = useLocation();
    const folder = location.pathname.split('/post-approval-document/')?.[1];

    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();
    const postApprovalColumn = useSelector((state) => state.column.postApproval);
    const { rawColumn } = usePostApprovalData({ folder });

    const getColumnSelection = () => {
        return rawColumn.filter((item) => !item.hiddenInTableColumn && !item.disableInColumnSelect);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const updateChecked = (key) => {
        const newPostApprovalColumn = produce(postApprovalColumn, (draft) => {
            const index = draft.findIndex((item) => item.key === key);

            if (index !== -1) {
                draft.splice(index, 1);
            } else {
                const defaultObject = rawColumn.find((item) => item.field === key);
                draft.push({ key, width: defaultObject.width });
            }
        });

        dispatch(updatePostApprovalColumn(newPostApprovalColumn));
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <SLayout>
            <CustomButton onClick={handleClick}>Hide/Show Columns</CustomButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <List>
                    {getColumnSelection().map((value) => {
                        const labelId = `checkbox-list-label-${value}`;

                        const isChecked = postApprovalColumn.some((item) => {
                            return item.key === value.field;
                        });

                        return (
                            <ListItem
                                dense
                                key={value.headerName}
                                button
                                onClick={() => {
                                    if (!value.mandatory) {
                                        updateChecked(value.field);
                                    }
                                }}
                            >
                                <ListItemIcon style={{ minWidth: 25 }}>
                                    <Checkbox
                                        disabled={value.mandatory}
                                        edge="start"
                                        checked={isChecked}
                                        tabIndex={-1}
                                        disableRipple
                                        style={{ padding: 3 }}
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={value.headerName} />
                            </ListItem>
                        );
                    })}
                </List>
            </Popover>
        </SLayout>
    );
};

export default PostApprovalColumnButton;
